<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.paciente"
        :disabled-button-search="true"
        ref="DataTable"
        search-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <slot
                name="actions"
                v-bind:item="item"
            >
            </slot>
        </template>

        <template v-slot:cell(dataNascimento)="row">
            {{ row.value | formatDate }}
        </template>

        <template v-slot:cell(cpf)="row">
            {{ row.value | formatCpf }}
        </template>

        <template v-slot:cell(cns)="row">
            {{ row.value | formatCns }}
        </template>
    </rkm-data-table>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            dispensacao: this.getConectaSusRepository('farmacia.dispensacao'),
        }
    },
    computed: {

        fields() {

            return [
                {
                    key: 'prontuario',
                    name: 'cadastro_paciente.prontuario',
                    label: 'Prontuário',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroCidadao.nome',
                    key: 'nome',
                    label: 'Nome (Nome social)',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nomeMae',
                    name: 'cadastro_cidadao.nome_mae',
                    label: 'Nome da Mãe',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataNascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    label: 'Data de nascimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cns',
                    name: 'cadastro_cidadao.cns',
                    label: 'CNS',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cpf',
                    name: 'cadastro_cidadao.cpf',
                    label: 'CPF',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.dispensacao.getMedicamentosAVencer()
                .then(({ data }) => {

                    if (data.medicamentosAVencer){
                        this.redirectRelatorio()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        redirectRelatorio() {
            const confirm = async () => {

                this.$emit('redirectRelatorio')
            }

            const msg = `O estoque da sua unidade possui medicamentos que irão vencer dentro de um período de 90 dias.
                Deseja acessar o relatório de validade de material?`

            this.showConfirmation(msg, confirm)

            return false
        },
    },
    mounted() {

        this.$nextTick(function () {

            if (this.relatorio) {

                this.load()
            }
        })
    },
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    mixins: [repository, error],
    props: {
        relatorio: { type: Boolean, default: true }
    },
}
</script>